import React from 'react';

import type { AssociateProfilePlacement } from 'src/services/associateProfile/types';
import { CaseSources } from 'src/utils/jmrUtils';
import type { RestrictionListParentTask, RestrictionListTask } from 'src/utils/restrictionUtilsLegacy';

import PlacementCardLayout from './placementCardLayout';
import PlacementInfo from './placementInfo';

interface ActivePlacementCardProps {
  placement: AssociateProfilePlacement;
  regionTasks?: (RestrictionListTask | RestrictionListParentTask)[];
  onTransferSuccess?: VoidFunction;
}

const ActivePlacementCard = ({ placement, regionTasks, onTransferSuccess }: ActivePlacementCardProps) => (
  <PlacementCardLayout placement={placement} regionTasks={regionTasks} onTransferSuccess={onTransferSuccess}>
    <PlacementInfo
      label="Injury"
      value={placement.injury}
      tooltip={placement.accommodationType === CaseSources.Dali ? 'DALI injury location not available' : undefined}
    />
    <PlacementInfo label="Start Date" value={new Date(placement.startAt).toLocaleDateString()} />
    <PlacementInfo label="End Date" value={new Date(placement.endAt).toLocaleDateString()} />
    <PlacementInfo label="Time In Active" value={placement.timeInStatus} />
    <PlacementInfo label="Job(s)" value={placement.allocatedJobShifts.length} />
  </PlacementCardLayout>
);

export default ActivePlacementCard;
